const RECONNECT_MS = 3000
const HEARTBEAT_MS = 30000
const HEARTBEAT_WAIT_MS = 7000

export default ({ customer, token, interests = {}, listeners = {}, onConnect, onDisconnect }) => {
  let ws = null
  let reconnectTimer = null
  let heartPing = null
  let heartTimer = null
  let heartWaitTimer = null
  let shouldReconnect = true

  const connect = () => {
    if (!customer || !token) return
    if (ws && [WebSocket.OPEN, WebSocket.CONNECTING].includes(ws.readyState)) return

    clearReconnect()
    ws = new WebSocket(`wss://${customer}.vonixcc.com.br/notifier?token=${token}`)
    ws.addEventListener('open', handleOpen)
    ws.addEventListener('message', handleMessage)
    ws.addEventListener('close', handleDisconnect)
    ws.addEventListener('error', handleDisconnect)
  }

  const close = () => {
    shouldReconnect = false
    clearReconnect()
    clearHeartbeat()

    if (ws) {
      unregisterSocket()
      ws.close()
      ws = null
    }

    if (typeof onDisconnect === 'function') onDisconnect()
  }

  const setInterests = (nextInterests = interests, forceRefresh = false) => {
    interests = nextInterests
    if (!ws || ws.readyState !== WebSocket.OPEN) return

    ws.send(JSON.stringify({
      act: 'setInterests',
      queues: toArrayStr(interests.queues),
      agents: toArrayStr(interests.agents),
      extensions: toArrayStr(interests.extensions),
      bots: toArrayStr(interests.bots),
      forceRefresh
    }))
  }

  const handleOpen = () => {
    if (typeof onConnect === 'function') onConnect()
    setInterests(interests, true)
    scheduleHeartbeat()
  }

  const handleMessage = ({ data }) => {
    const event = forceParseJSON(data)
    if (event?.heartPong === heartPing) return scheduleHeartbeat()

    const eventName = event?.event?.event?.toUpperCase()?.trim()
    if (!eventName || typeof listeners[eventName] !== 'function') return

    listeners[eventName](event)
  }

  const handleDisconnect = () => {
    clearHeartbeat()
    const closedWs = ws
    unregisterSocket()
    ws = null

    try {
      closedWs?.close()
    } catch (err) {
      console.log(err)
    }

    if (typeof onDisconnect === 'function') onDisconnect()
    if (!shouldReconnect) return

    clearReconnect()
    reconnectTimer = setTimeout(connect, RECONNECT_MS)
  }

  const unregisterSocket = () => {
    if (!ws) return
    ws.removeEventListener('open', handleOpen)
    ws.removeEventListener('message', handleMessage)
    ws.removeEventListener('close', handleDisconnect)
    ws.removeEventListener('error', handleDisconnect)
  }

  const scheduleHeartbeat = () => {
    clearHeartbeat()
    heartTimer = setTimeout(sendHeartbeat, HEARTBEAT_MS)
  }

  const sendHeartbeat = () => {
    if (!ws || ws.readyState !== WebSocket.OPEN) return

    heartPing = Date.now()
    ws.send(JSON.stringify({ heartPing }))
    heartWaitTimer = setTimeout(() => ws?.close(), HEARTBEAT_WAIT_MS)
  }

  const clearHeartbeat = () => {
    heartPing = null
    if (heartTimer) clearTimeout(heartTimer)
    if (heartWaitTimer) clearTimeout(heartWaitTimer)
    heartTimer = null
    heartWaitTimer = null
  }

  const clearReconnect = () => {
    if (reconnectTimer) clearTimeout(reconnectTimer)
    reconnectTimer = null
  }

  connect()

  return {
    close,
    connect,
    setInterests
  }
}

const toArrayStr = (value) => {
  if (!value) return []
  const values = Array.isArray(value) ? value : [value]
  return values.map(item => String(item))
}

const forceParseJSON = (str) => {
  try {
    return JSON.parse(str)
  } catch {
    return {}
  }
}
